import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ResetPasswordTokenController extends Controller {
  declare model: { changeset: any };

  @tracked saving = false;
  @tracked success = false;
  @tracked error?: any;
  @tracked showValidationErrors = false;

  templateWillDestroy = () => {
    this.error = undefined;
    this.showValidationErrors = false;
    this.success = false;
    this.saving = false;
  }

  save = async () => {
    if (this.saving) {
      return;
    }
    const changeset = this.model.changeset;
    try {
      await changeset.validate();
      if (changeset.isValid) {
        this.showValidationErrors = false;
        await changeset.save();
        this.success = true;
      } else {
        this.showValidationErrors = true;
      }
    } catch (error) {
      this.error = error;
    }
  }
}
